module.exports = __webpack_public_path__ + "assets/img/INTERIOR8.e719c585.png";